import React from 'react';

import * as S from './styles';
import { theme } from '../../styles/theme';
import { TaglinePSpan } from '../../styles/stylesTypography';
import IconSearchNotFound from '../../assets/icons/icons8-search-notfound.png';

// Estado vazio genérico ("nenhuma informação encontrada") - ícone de lupa +
// mensagem, extraído do padrão repetido em vários relatórios (ex.:
// culturas-frequentes-por-periodo.js). `message` é opcional, pra reusar em
// telas com um texto diferente; `iconSize`/`textSize` (opcionais) ajustam o
// tamanho do ícone (max-width) e do texto (font-size) via style inline, sem
// mexer no padrão (80px/0.5625rem) quando não informados.
const NotFound = ({ message = 'Nenhuma informação encontrada!', iconSize, textSize, gap,...props }) => {
    return (
        <S.Container gap={gap} {...props}>
            <img
                src={IconSearchNotFound}
                alt="Ícone de pesquisa"
                style={iconSize ? { maxWidth: iconSize } : undefined}
            />

            <TaglinePSpan
                color={theme.colors.gray.Cinza_2}
                style={textSize ? { fontSize: textSize } : undefined}
            >
                {message}
            </TaglinePSpan>
        </S.Container>
    );
}

export default NotFound;
